import {
    NinchatActionType,
    NinchatRemoveFileUnlinkedAction,
} from '../types/actions'

import /* ninchatClient, */ {
    NinchatActionParams,
} from '../NinchatClient'


import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const removeUnlinkedFile = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatRemoveFileUnlinkedAction}`,
    // eslint-disable-next-line require-await
    async (arg: NinchatActionParams<NinchatRemoveFileUnlinkedAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatRemoveFileUnlinkedAction

        try {
            return true
            // There is no API to remove unlinked file, so we just return true here and handle the state update in the component
            // return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
